(function ($) {
    'use strict';

    $(function () {
        const $carousel = $('.js-carousel-nav');
        if (!$carousel.length) return;

        const $slides = $('.js-hero-slide');
        const $scholar = $('.js-hero-scholar');
        const $prev = $('.js-hero-nav-prev');
        const $next = $('.js-hero-nav-next');
        const numSlides = $slides.length;
        const activeClass = 'is-active';

        const goToSlide = (index) => {
            // Handle going to start/end of carousel
            if (index < 0) index = numSlides - 1;
            if (index >= numSlides) index = 0;

            // Update the current slide
            $slides.removeClass(activeClass).attr('aria-hidden', 'true');
            $slides.filter(`[data-index="${index + 1}"]`).addClass(activeClass).attr('aria-hidden', 'false');

            // Update the scholar slide
            if ($scholar.length) {
                $scholar.removeClass(activeClass).attr('aria-hidden', 'true');
                $scholar.filter(`[data-index="${index + 1}"]`).addClass(activeClass).attr('aria-hidden', 'false');
            }
        }

        $prev.on('click', (e) => {
            e.preventDefault();
            const currentIndex = $slides.filter(`.${activeClass}`).data('index') - 1;
            goToSlide(currentIndex - 1);
        });

        $next.on('click', (e) => {
            e.preventDefault();
            const currentIndex = $slides.filter(`.${activeClass}`).data('index') - 1;
            goToSlide(currentIndex + 1);
        });
    });
})(jQuery);
